import React from "react";
import "./certificates.css";
import react_img from "./images/react.png";
import deep_learning_img from "./images/deep_learning.png";
import machine_learning_img from "./images/machine_learning.png";
import nlp_img from "./images/nlp.png";
import tensorflow_img from "./images/tensorflow.png";
import "bootstrap/dist/css/bootstrap.min.css";

const Certificates = () => {
  return (
    <div className="certificates" id="certificates">
      <h1>Certificates</h1>
      <div className="row">
        <div className="col">
          <a
            href="https://www.coursera.org/account/accomplishments/specialization/QQ6YSCUQ7A6H"
            target="_blank"
            rel="noopener noreferrer"
            title="NLP Specialization Certificate"
          >
            <img src={nlp_img} alt="NLP Specialization"></img>
          </a>
        </div>
        <div className="col">
          <a
            href="https://www.coursera.org/account/accomplishments/specialization/M3YXH4QVP7DC"
            target="_blank"
            rel="noopener noreferrer"
            title="Deep Learning Specialization Certificate"
          >
            <img
              src={deep_learning_img}
              alt="Deep Learning Specialization"
            ></img>
          </a>
        </div>
        <div className="col">
          <a
            href="https://www.coursera.org/account/accomplishments/specialization/EPYDJB2KLV6R"
            target="_blank"
            rel="noopener noreferrer"
            title="TensorFlow Specialization Certificate"
          >
            <img src={tensorflow_img} alt="Tensorflow Specialization"></img>
          </a>
        </div>
        <div className="col">
          <a
            href="https://www.coursera.org/account/accomplishments/records/ANMCUMCPPYD8"
            target="_blank"
            rel="noopener noreferrer"
            title="Machine Learning Certificate"
          >
            <img src={machine_learning_img} alt="Machine Learning"></img>
          </a>
        </div>
        <div className="col">
          <a
            href="https://coursera.org/share/558d091161ad935020239da513625caf"
            target="_blank"
            rel="noopener noreferrer"
            title="React JS Certificate"
          >
            <img src={react_img} alt="React JS"></img>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Certificates;
